<template>
  <div
    class="i-navbar-item-mobile"
    :class="{ active: props.item.isActive }"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @click="props.item.action"
  >
    <img
      class="icon"
      :src="props.item.isActive ? props.item.icons.active : props.item.icons.default"
      :alt="props.item.text + ' icon'"
    />

    <div class="text">
      {{ props.item.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { type PropType, ref } from "vue"

import type { NavigationItem } from "@/types/navigationItem"

const props = defineProps({
  item: {
    type: Object as PropType<NavigationItem>,
    required: true
  }
})

// Reactive state to track hover
const isHovered = ref(false)

// Event handlers to update hover state
const handleMouseEnter = () => {
  isHovered.value = true
}

const handleMouseLeave = () => {
  isHovered.value = false
}
</script>

<style scoped lang="scss">
.i-navbar-item-mobile {
  @include flex(column, center, center, $gap: 2px);

  padding: 4px;
  height: 40px;
  cursor: pointer;
  color: $black900;

  &.active {
    color: $azure-radiance500;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  .text {
    display: none;
    text-align: center;

    @media screen and (min-width: $breakpoint-xxs) {
      display: block;

      @include text-xxs;

      font-weight: 500;
    }

    @media screen and (min-width: $breakpoint-xs) {
      @include text-xs;
    }
  }
}
</style>
